// extracted by mini-css-extract-plugin
export var alertIcon = "_px-0";